let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("441S4")).then(() => parcelRequire('g1DyE'));